import YesIcon from 'assets/images/yes-icon.svg';

import SuccessImage from 'assets/images/create-success.svg';
import CancelRenewalImage from 'assets/images/cancel-renewal-v2.svg';
import CanceSubslImage from 'assets/images/sad-smiley.svg';
import ThumbsupImage from 'assets/images/thumbsup-smiley.svg';

import Logo from 'assets/images/logo.svg';
import Theme from 'theme';

const {
  REACT_APP_GROUP_ID: groupId,
  REACT_APP_CLIENT_HEADER: clientHeader = groupId,
} = process.env;

const locations = [
  { key: 'LOC1', name: 'Broomfield'},
  { key: 'LOC2', name: 'Casper'},
  { key: 'LOC3', name: 'Cheyenne'},
  { key: 'LOC4', name: 'Colorado Springs'},
  { key: 'LOC5', name: 'Denver Tech Center'},
  { key: 'LOC6', name: 'Encinitas'},
  { key: 'LOC7', name: 'Erie'},
  { key: 'LOC8', name: 'Fort Collins'},
  { key: 'LOC9', name: 'Glendale-Cherry Creek'},
  { key: 'LOC10', name: 'Greeley'},
  { key: 'LOC11', name: 'Highlands Ranch'},
  { key: 'LOC12', name: 'La Jolla'},
  { key: 'LOC13', name: 'La Mesa'},
  { key: 'LOC14', name: 'Lakewood'},
  { key: 'LOC15', name: 'Lone Tree'},
  { key: 'LOC16', name: 'Longmont'},
  { key: 'LOC17', name: 'Loveland'},
  { key: 'LOC18', name: 'Mission Valley'},
  { key: 'LOC19', name: 'Norman, OK'},
  { key: 'LOC20', name: 'Northfield'},
  { key: 'LOC21', name: 'Oklahoma City, OK'},
  { key: 'LOC22', name: 'Riverfront-LoHi'},
  { key: 'LOC23', name: 'Roxborough'},
  { key: 'LOC24', name: 'Thornton'},
  { key: 'LOC25', name: 'Westminster'}
];

const locationApptLinks = locations.map((loc) => {
  const {
    [`REACT_APP_${loc.key}_APPT_LINK`]: locApptLink,
  } = process.env;
  return {
    name: loc.name,
    link: locApptLink,
    target: '_blank',
  };
});

const config = {
  groupId,
  logo: Logo,
  cptCodesIcon: YesIcon,
  portalName: 'Espire Dental',
  // Industry drives the Strapi FAQ template (SAP-7671). Omit to default to 'dental'.
  // Valid: dental | primary-care | chiropractic | dermatology | urgent-care | veterinary
  industry: 'dental',
  tokenName: 'espireSubscriberToken',
  globalClass: 'espire-container',
  clientHeader,
  enableHeroButton: true,
  pricingType: 'standard-pricing',
  headerProps: {
    enable: false,
  },
  localeProps: {
    enable: true,
    localesList: [
      {
        key: 'en',
        value: 'English',
      },
      {
        key: 'es',
        value: 'Spanish',
      },
    ],
  },
  homeTemplateProps: {
    heroSection: {
      variant: 2,
      titleClasses: 'home-hero-title',
      subTitleClasses: 'home-hero-subtitle',
      primaryButtonProps: {
        to: '/find-a-provider',
      },
      secondaryButton: 'Login',
      secondaryButtonProps: {
        to: '/login',
      },
      background: '/images/home-images/home-banner-img.webp',
    },
    benefitsSection: {
      variant: 2,
      columns: 3,
      heroImage: '/images/home-images/benefits.webp',
      alignTitle: 'center',
      alignCard: 'center',
    },
    subscriptionSection: {
      tabVariant: 2,
      carouselResponsiveItems: {
        desktop: 3,
      },
      planCardProps: {
        buttonProps: {
          highlightedColor: 'primary',
          highlightedVariant: 'contained',
        },
        alignCptDisclaimer: 'bottom',
        enableTextAgeDisclaimer: true
      },
    },
    howItWorksSection: {
      variant: 2,
      alignTitle: 'left',
      subtitle: 'Getting started with the Espire Care Plan is simple.',
      heroImage: '/images/home-images/how-it-works.webp',
      working_steps : [
        {
          "title": "Sign Up and Pay",
          "content": "Subscribe and pay conveniently online or at your local Espire practice. It's quick and easy, taking only a few minutes."
        },
        {
          "title": "Visit Your Dentist for Treatment",
          "content": "Schedule appointments with your dentist as needed."
        },
        {
          "title": "Give Feedback",
          "content": "Share your experience with your dentist to help us maintain and improve the quality of care you receive!"
        }
      ]
    },
    testimonialSection: {
      variant: 1,
      messageType: 'h6',
      gridSpacing: {
        xSmall: 12,
        medium: 12,
      },
      carouselResponsiveItem: {
        superLarge: 1,
        large: 1,
      },
    },
    staticHeroSection: {
      enable: true,
      variant: 1,
      primaryButtonProps: {
        color: 'primary',
      },
    },
  },
  checkoutSection: {},
  findProviderSection: {
    locationWrapper: 7,
    mapWrapper: 5,
    heroProps: {
      secondaryButtonProps: {
        variant: 'contained',
        color: 'primary',
      },
    },
  },
  choosePlanSection: {
    sectionSubtitle: '',
    locationLogo: Logo,
    cardVariant: 2,
    tabVariant: 2,
    planCardProps: {
      buttonProps: {
        normalColor: 'primary',
        highlightedColor: 'primary',
        normalVariant: 'contained',
        highlightedVariant: 'outlined',
      },
      alignCptDisclaimer: 'bottom'
    },
    staticHeroSection: {
      enable: true,
      variant: 1
    },
  },
  subscriptionSuccess: {
    successImage: SuccessImage,
    enableBookAppointment: true,
    bookAppointmentProps: {
      target: '_blank',
      locationList: locationApptLinks,
    },
  },
  savingsSummary: {
    enableFooterbar: true,
    enableSelectLocation: true,
    showCategoryHeaders: true,
    heroProps: {
      secondaryButtonProps: {
        variant: 'contained',
        color: 'primary',
      },
    },
    locationIcon: '/images/locationIcon.svg',
    contactSection: 'contactDetails',
    moreSavingsButtonProps: {
      variant: 'outlined',
      color: 'primary'
    }
  },
  faqSection: {
    heroProps: {
      secondaryButtonProps: {
        variant: 'contained',
        color: 'primary',
      },
    },
  },
  dashboardProps: {
    showBenefitsUsage: true,
    cancelRenewal: {
      image: CancelRenewalImage,
    },
    cancelSubscription: {
      image: CanceSubslImage,
    },
    reactivateRenewal: {
      image: ThumbsupImage,
    },
  },
  bookAppointment: {
    enableBookAppointment: true,
  },
  footer: {
    enable: false
  },
  loginPage: {
    bannerImage: './images/login.webp',
  },
  theme: Theme,
};

export default config;
